import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment } from 'react';
import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { roleUser } from '../../../utils/roleUser';
import { APIClient } from '../../../helpers/api_helper';
import * as url from '../../../helpers/url_helper';
import { DefaultSelect } from '../../../components/inputs/DefaultInput';

const apiClient = new APIClient();

export function ReporteUtmLeads() {

    const navigate = useNavigate();
    const [messsageAlert, setMessageAlert] = useState("");
    const [isOpenSuccess, setIsOpenSuccess] = useState();
    const [isOpenError, setIsOpenError] = useState();
    const [viewalert, setViewalert] = useState(false);
    const [hasView, setHasView] = useState(false);
    const [initDate, setInitDate] = useState('');
    const [finishDate, setFinishDate] = useState('');
    const [partner, setPartner] = useState('');
    const [errors, setErrors] = useState({});
    const [partnersOptions, setPartnersOptions] = useState([]);

    const getInfoRole = async (doc) => {
        try {
            let response = await HttpRequest.getInfoRole(doc);
            return response.message;
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    const handleOpenAlert = (type, message, isOpen) => {
        if (type === 'success') {
            setMessageAlert(message);
            setIsOpenSuccess(isOpen);
            setViewalert(true);
        }
        if (type === 'error') {
            setMessageAlert(message);
            setIsOpenError(isOpen);
            setViewalert(true);
        }
    }

    const handleClearStateAlert = () => {
        setViewalert(false);
        setMessageAlert("");
        setIsOpenSuccess(false);
        setIsOpenError(false);
    }

    const handleChangeInitdate = (event) => {
        setInitDate(event.target.value);
    };

    const handleChangeFinishdate = (event) => {
        setFinishDate(event.target.value);
    };

    const handleChangePartner = (event) => {
        setPartner(event.target.value);
    };

    const validateInputs = () => {
        const newErrors = {};
        if (!initDate || initDate === '') {
            newErrors.initDate = 'La fecha inicial es requerida.';
        }
        if (!finishDate || finishDate === '') {
            newErrors.finishDate = 'La fecha final es requerida.';
        }
        if (!partner || partner === '') {
            newErrors.partner = 'El partner es requerido.';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Devuelve true si no hay errores
    };

    const handleGetPartners = async () => {
        try {
            let response = await apiClient.get(url.GET_PARTNERS);
            return response.data?.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const handleSubmit = async (e) => {
        handleClearStateAlert()
        e.preventDefault();
        if (!validateInputs()) return;
        try {
            let response = await apiClient.get(url.REPORT_UTM_LEADS, { initDate, finishDate, status: 'CREDITO FIRMADO', partner });
            if (response.status === 200) {
                if (response.data?.data) {
                    let data = response.data.data;
                    const csv = data.map(row => row.join(',')).join('\r\n');
                    let partnerName = partnersOptions.filter(item => item.value === partner)[0]?.label;
                    let fileName = `reporte_utm_leads_${partnerName}_${initDate}_${finishDate}.csv`;
                    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    if (link.download !== undefined) {
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        URL.revokeObjectURL(url);
                        handleOpenAlert('success', "Reporte generado exitosamente", true);
                        setInitDate('');
                        setFinishDate('');
                        setPartner('');
                    }
                }
            } else {
                handleOpenAlert('error', response.data?.message, true);
            }
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', error.message, true);
        }
        setTimeout(() => {
            handleClearStateAlert();
        }, 6000);
    }

    useEffect(() => {
        (async () => {
            let response = await handleGetPartners();
            if(Array.isArray(response) && response.length > 0) {
                let parsedPartners = response.map((partner) => {
                    return {
                        value: partner?.partnerId,
                        label: partner?.name
                    }
                });
                parsedPartners.unshift({value: '', label: 'Selecciona un partner'});
                parsedPartners.push({value: 'all', label: 'Todos'});
                setPartnersOptions(parsedPartners);
            }
        })();
    }, []);

    useEffect(() => {
        let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then((infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');
                            setHasView(true);
                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }
    }, []);

    if (!hasView) {
        return (<span>Cargando...</span>)
    } else {
        return (
            <Fragment>
                {
                    viewalert ?
                        <>
                            <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
                            <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
                        </>
                        : <></>
                }

                <DashboardsBackOffice
                    name={'Admin'}
                    balance={0}
                    current12={true}
                    title={'Reporte Utm Leads'}
                    main={
                        <>
                            <form action="#" method="POST">
                                <div className='px-4 mt-3 py-5 bg-white sm:p-6'>
                                    <div className="grid grid-cols-8 gap-6">
                                        <div className="col-span-4 sm:col-span-4 mt-4">
                                            <label
                                                htmlFor="initialdate"
                                                className="block text-sm font-medium"
                                            >
                                                Fecha inicial
                                            </label>
                                            <div>
                                                <input
                                                    value={initDate}
                                                    onChange={handleChangeInitdate}
                                                    type="date"
                                                    name="initialdate"
                                                    id="initialdate"
                                                    maxLength="40"
                                                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                                />
                                            </div>
                                            {errors.initDate && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.initDate}</span>)}
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-8 gap-6">
                                        <div className="col-span-4 sm:col-span-4 mt-4">
                                            <label
                                                htmlFor="finishdate"
                                                className="block text-sm font-medium"
                                            >
                                                Fecha final
                                            </label>
                                            <div>
                                                <input
                                                    value={finishDate}
                                                    onChange={handleChangeFinishdate}
                                                    type="date"
                                                    name="finishdate"
                                                    id="finishdate"
                                                    maxLength="40"
                                                    className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                                />
                                            </div>
                                            {errors.finishDate && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.finishDate}</span>)}
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-8 gap-6">
                                        <div className="col-span-4 sm:col-span-4 mt-4">
                                            <label
                                                htmlFor="cellPhone"
                                                className="block text-sm font-medium"
                                            >
                                                Partner
                                            </label>
                                            <div>
                                                <DefaultSelect
                                                    option={partnersOptions || []}
                                                    onChange={handleChangePartner}
                                                    value={partner}
                                                />
                                            </div>
                                            {errors.partner && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.partner}</span>)}
                                        </div>
                                    </div>

                                    <div className="md:w-56 pt-3 mt-3">
                                        <button
                                            onClick={handleSubmit}
                                            type="button"
                                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                        >
                                            <div className="flex">
                                                {'Generar reporte'}
                                                <div className="grid content-center pl-2">{ }</div>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </form>

                        </>
                    }
                />

            </Fragment>
        );
    }


}
